<template>
  <div class="suggestionTaking" style="margin-top: 220px;">
    <div class="shop-carBox comWidth">
      <div class="z_proposal">
        <h2>極草·5X冬蟲夏草純粉片（經典含片）服用建議</h2>
        <h3>滋補養生</h3>
        <img src="../../assets/ce/z_proposal1.jpg" alt="">
        <h3>康復調理</h3>
        <img src="../../assets/ce/z_proposal2.jpg" alt="">
        <img src="../../assets/ce/z_proposal4.png" alt="">
      </div>
    </div>
    <!--导航-->
    <NavB :titleChild="titleChild"/>
  </div>
</template>

<script>
  import NavB from '@/pages/detailsPage/NavB'
  export default {
    name: 'SuggestionTaking',
    components:{
      NavB
    },
    data () {
      return {
        titleChild:[{name:'首頁',src:'HomePage'},{name:'極草產品',src:'ProductPage'},{name:'冬蟲夏草純粉片服用建議',src:'SuggestionTaking'}],
      }
    },
    created(){
      window.scrollTo(0,0)
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
  .z_proposal {
    width:100%;
    h2{
      font-size: 30px;
      text-align: center;
      color: #535353;
      margin-bottom: 40px;
    }
    h3{
      text-align: center;
      font-size: 24px;
      color: #af782d;
    }
    img{
      width: 100%;
      display: block;
      margin-top: 20px;
      margin-bottom: 55px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/product/SuggestionTaking.vue